import type { VariantProps } from 'class-variance-authority'
import { forwardRef, HTMLAttributes } from 'react'
import { card } from './Card/styles'
import { cn } from '~/utils/cn';

type CardProps = Omit<HTMLAttributes<HTMLDivElement>, 'color'> & VariantProps<typeof card>

export const Card = forwardRef<HTMLDivElement, CardProps>(({ children, className, color, size, ...props }, ref) => (
    <div ref={ref} {...props} className={cn(card({ color, size, className }))}>
        {children}
    </div>
))